:host {
    display: block;
    font-family: soleil, sans-serif;
    font-style: normal;
    color: var(--rs-color-heading);
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

h1, h2, h3, h4, h5 {
    margin: 0;
    padding: 0;
    line-height: 1.2em;
}

h1 {
    font-weight: 600;
    font-size: 50px;
}

h2 {
    font-weight: 600;
    font-size: 38px;
}

h3 {
    font-weight: 600;
    font-size: 26px;
}

h4 {
    font-weight: 700;
    font-size: 22px;
}

h5 {
    font-weight: 600;
    font-size: 16px;
}
